import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk"; // Add-on you might want
import rootReducer from "../reducers";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import { store as reduxStore } from "@stencil/redux";
import LogRocket from "logrocket";
import healthIntegration from "../stencil-store/health.store";
import { restoreStore } from "../stencil-store/utils/persist-state";

export const store = reduxStore;

export const configureStore = async (preloadedState: Partial<SworkitState>) => {
  //stencil store integrations
  await Promise.all([
    restoreStore(healthIntegration)
  ]);
  //TODO: state management from stencil redux to stencil store
  return createStore(
    rootReducer,
    preloadedState,
    composeWithDevTools(
      applyMiddleware(
        thunk,
        LogRocket.reduxMiddleware({
          stateSanitizer: logRocketStateSanitizer,
        }),
      ),
    ),
  );
};

const logRocketStateSanitizer = (state: SworkitState) => {
  const newState: SworkitState = {
    ...state,
    customWorkouts: {
      ...state.customWorkouts,
      customEditWorkoutsById: {},
      sortedCustomWorkoutIds: [],
    },
  };
  return newState;
};

export function getUserName() {
  const state = store.getState() as SworkitState;
  const firstName = state.user.profile.firstName;
  const lastName = state.user.profile.lastName;
  if (!firstName && !lastName) {
    return "";
  }
  return `${firstName || ""} ${lastName || ""}`;
}
